import { css } from 'emotion';
import { JOB_PANEL_WIDTH } from '../../dispatch.style';
import { DRIVER_TAB_WIDTH } from '../drivers/drivers.style';
import theme from '@vromo/ui/components/theme';


export default {
    container: css`
        position: absolute;
        top: 20px;
        left: ${DRIVER_TAB_WIDTH + 50}px;
        width: calc(100vw - ${DRIVER_TAB_WIDTH + JOB_PANEL_WIDTH + 170}px);
        min-width: 200px;
        min-height: 109px;
        background-color: white;
        display: flex;
        flex-direction: column;
        padding-top: 15px;
        padding-bottom: 15px;
        padding-left: 56px;
        padding-right: 20px;
        overflow: hidden;
        border-radius: 8px;

        @media (min-width: 1001px) and (max-width: 1165px) {
            min-width: 275px;
            width: 275px;
            top: 150px;
            left: 20px;
        }

        @media (max-width: 1001px) {
            left: 25%;
            margin-top: 20px;
            width: 60vw;
        }
    `,
    title: css`
        font-size: 18px;
        font-weight: bold;
        color: ${theme.primary};
        margin-bottom: 2px;
    `,
    closeIcon: css`
        position: absolute;
        top: 12px;
        right: 12px;
        cursor: pointer;
        color: ${theme.mediumGrey};
    `,
    betaTag: css`
        position: absolute;
        top: 0px;
        left: 0px;
        width: 60px;
        height: 60px;
    `
};
